import PaintCommercialAnalysisWorkspace from '../../placeholders/PaintCommercialAnalysisWorkspace';

export default PaintCommercialAnalysisWorkspace;
